import { compose, lifecycle, withStateHandlers } from 'recompose'
import { connect } from 'react-redux'
import { isEqual } from 'lodash'
import { getCurrentStoreNumber } from 'selectors/getCurrentStore'
import { getUserData } from 'components/Appointment/selectors'
import { getVisibleProductsForInventory, getGbbProductsForInventory } from 'components/OneColumnSearchResultPage/selectors'
import { setInventoryForVisibleProducts } from 'components/OneColumnSearchResultPage/actions'
import MainSearchResult from './MainSearchResult'
import { inventoryDataReset } from '../../actions'
import { getFiltersData } from '../../selectors'

const mapStateToProps = state => {
  const { isPilotStore } = getUserData(state)
  const { selectedFilters } = getFiltersData(state)

  return {
    storeNumber: getCurrentStoreNumber(state),
    visibleProductsForInventory: getVisibleProductsForInventory(state),
    gbbProductsForInventory: getGbbProductsForInventory(state),
    isPilotStore,
    selectedFilters
  }
}

export const withProductsDataStatusState = withStateHandlers(() => ({
  inventoryHasProcessed: false,
  gbbProductsReceived: false,
  visibleProductsReceived: false
}), {
  setInventoryHasProcessed: () => (inventoryHasProcessed) => ({ inventoryHasProcessed }),
  setGbbProductsReceived: () => (gbbProductsReceived) => ({ gbbProductsReceived }),
  setVisibleProductsReceived: () => (visibleProductsReceived) => ({ visibleProductsReceived })
})

const withInitializationAndUpdating = lifecycle({
  componentDidUpdate({
    storeNumber: prevStoreNumber,
    visibleProductsForInventory: prevVisibleProductsForInventory,
    gbbProductsForInventory: prevGbbProductsForInventory,
    selectedFilters: prevSelectedFilters
  }) {
    const {
      visibleProductsForInventory,
      gbbProductsForInventory,
      gbbProductsReceived,
      setGbbProductsReceived,
      visibleProductsReceived,
      setVisibleProductsReceived,
      inventoryHasProcessed,
      setInventoryForVisibleProducts,
      storeNumber,
      setInventoryHasProcessed,
      isPilotStore,
      selectedFilters,
      inventoryDataReset
    } = this.props
    const isStoreChanged = !isEqual(storeNumber, prevStoreNumber)
    const visibleProductsChanged = !isEqual(visibleProductsForInventory, prevVisibleProductsForInventory)
    const gbbProductsChanged = !isEqual(gbbProductsForInventory, prevGbbProductsForInventory)
    const selectedFiltersChanged = !isEqual(selectedFilters, prevSelectedFilters)

    if (selectedFiltersChanged && isPilotStore) {
      setVisibleProductsReceived(false)
      inventoryDataReset()
    }

    // Checking if GBB products and visible products from TireResultList was set and we can call inventory API
    !gbbProductsReceived && (gbbProductsForInventory !== undefined) && setGbbProductsReceived(true)
    !visibleProductsReceived && (visibleProductsForInventory !== undefined) && setVisibleProductsReceived(true)

    if (!inventoryHasProcessed && gbbProductsReceived && visibleProductsReceived && isPilotStore) {
      setInventoryForVisibleProducts({
        visibleRecords: visibleProductsForInventory,
        gBBDetails: gbbProductsForInventory,
        storeNumber
      })
      setInventoryHasProcessed(true)
    }

    if (inventoryHasProcessed
        && (visibleProductsChanged
          || gbbProductsChanged
          || (isStoreChanged && isPilotStore))
    ) {
      setInventoryForVisibleProducts({
        visibleRecords: visibleProductsForInventory,
        gBBDetails: gbbProductsForInventory,
        storeNumber
      })
    }
  },
  componentWillUnmount() {
    const { inventoryDataReset } = this.props

    inventoryDataReset()
  }
})

export default compose(
  connect(mapStateToProps, { setInventoryForVisibleProducts, inventoryDataReset }),
  withProductsDataStatusState,
  withInitializationAndUpdating
)(MainSearchResult)
